import { LICENSE_LEVELS } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";
import { useI18n } from "../i18n";

const COLORS = ["#2563EB", "#0D9488", "#16A34A", "#EA580C", "#7C3AED", "#DB2777"];

export default function Licensing() {
  const { tr } = useI18n();
  return (
    <section id="licensing" data-testid="territory-licensing-section" className="py-24 lg:py-32 bg-[#FFF7ED] border-y wp-rule">
      <SectionHead
        index="§ 06"
        eyebrow="Territory Licensing"
        title="Every territory on Earth becomes licensable."
        sub="Local partners operate their territory — the platform retains the technology, the geographic graph, identity, Social Capital and the community's history."
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-14">
        <div className="max-w-3xl mx-auto space-y-2">
          {LICENSE_LEVELS.map((l, i) => (
            <Reveal key={l.adm} delay={i * 0.08} y={18}>
              <div
                data-testid={`licensing-level-adm${i}`}
                style={{ width: l.width }}
                className="mx-auto group"
              >
                <div
                  className="border rounded-2xl bg-white px-4 md:px-6 py-4 flex items-center justify-between gap-3 transition-all duration-300 wp-lift"
                  style={{ borderColor: COLORS[i] }}
                >
                  <span className="font-mono-wp text-[0.6rem] md:text-[0.65rem] uppercase tracking-[0.18em]" style={{ color: COLORS[i] }}>{l.adm}</span>
                  <span className="font-atlas text-base md:text-xl text-[#0F2557] whitespace-nowrap">{tr(l.role)}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <p className="text-center font-mono-wp text-xs text-[#92400E] mt-10 max-w-xl mx-auto leading-relaxed">
            {tr("LICENSING ADMINISTRATION ≠ DATA OWNERSHIP. When a license ends, the community's contributions, history and identity remain with the ecosystem.")}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
